import { HomePageTile } from "slot-definitions"
import { hasDemand } from "lib/authorization/has-demand"
import { Welcome } from "routes/schedule/plugins/homepage/welcome/welcome"

HomePageTile.plug(<Welcome if={() => hasDemand("$!sharing")} priority={10} />)
